<script lang="ts" setup>
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { api } from '../../../../shared/api/client.ts';
  import { messageOf } from '../../../../shared/api/serverFailure.ts';
  import { route } from '../../../../shared/config/routes.ts';
  import { startUserAction, userAction } from '../../../../shared/observability/userAction.ts';
  import { usePlayerSession } from '../../model/playerSession.ts';
  import GameCodeView from './GameCodeView.vue';

  const router = useRouter();
  const err = ref<string>('');
  const codeErr = ref<string>('');
  const { problem: sessionProblem, session, rejoinGame } = usePlayerSession({ asHost: false });

  const verifyGameCode = async (code: string) => {
    startUserAction(userAction.registrationVerifyGameCode);
    const { error } = await api.GET('/games/{code}', { params: { path: { code: Number(code) } } });

    if (!error) {
      await router.push({ name: route.playerRegister, params: { gameCode: code } });
      return;
    }

    const refusesTheCode = error.slug === 'game-not-found' || error.slug === 'invalid-game-code';
    codeErr.value = refusesTheCode ? error.message : '';
    err.value = refusesTheCode ? '' : messageOf('gameInProgressByCode', error);
  };
</script>

<template>
  <GameCodeView
    :code-error="codeErr"
    :error="err || sessionProblem"
    :session="session"
    @game-code="verifyGameCode"
    @rejoin="rejoinGame"
  />
</template>
